export const ComponentPlacementDescriptions = {
  selector:
    "Selector-mode placement: CSS selector for the anchor element the upsell is inserted near. Unset when anchorKey is used.",
  insertType:
    "Selector-mode placement: where, relative to the anchor element, the upsell is inserted (before/after, inside start/end). Unset when anchorKey is used.",
  anchorKey:
    "Anchor-mode placement: the key a merchant gave the Intelligems Content theme app block. The upsell renders inside every block on the page carrying this key. Unset when selector is used.",
  location:
    "Semantic page context this upsell renders in (pdp or cart). Drives the plugin's activation/re-render strategy and labels/groups the upsell in analytics.",
} as const;

export const OnsiteUpsellRuleDescriptions = {
  id: "Stable identifier for this rule. Owns the rule's targeting row(s) in the targeting table.",
  priority:
    "Evaluation order. Lower numbers are checked first; the first rule whose targeting matches wins.",
  action:
    "Which products to load when this rule matches (Shopify recommendations, specific products, collection, or tag).",
  targeting:
    "When this rule shows. Boolean expression over the chosen domain, evaluated to decide whether the upsell renders.",
} as const;

export const OnsiteUpsellConfigDescriptions = {
  type: "Discriminator for the component kind.",
  placement: "Where in the DOM the rendered upsell is injected.",
  template:
    "HTML for the upsell, including all static copy written inline. The per-product card is the markup between {{#each products}} and {{/each}}. May only reference declared slots: product.* data slots and the named slots (atc, variant-select); everything else is literal HTML.",
  maxProductLimit: "Maximum number of products to render.",
  excludeOutOfStock:
    "Exclude products whose variants are all out of stock. Defaults to true.",
  excludeItemsInCart:
    "Exclude products already in the shopper's cart. Defaults to true.",
  discount: "Optional discount applied to products added from this upsell.",
  rules:
    "Prioritized list of rules. Each pairs an action (which products) with targeting (when to show). v1 ships a single rule.",
  agenticLogicPlacementId:
    "Agentic Logic placement this upsell evaluates through. Absent means the legacy rule engine serves it — clearing the mapping is the per-surface rollback.",
  agenticLogicRuleId:
    "WRITE-SIDE intent: the Agentic Logic rule this upsell should serve. The experience save upserts the placement and the (placement, variation) assignment from it and stamps `agenticLogicPlacementId`, so callers never assemble that pair themselves. Null detaches the component and returns it to the legacy engine. Reads echo the rule currently assigned; the field is never persisted in the stored config.",
} as const;

export const ComponentDtoDescriptions = {
  id: "Server-generated. Read-only.",
  variationId: "References the parent variation this component belongs to.",
  config:
    "The saved upsell: its type, look, products, targeting, and discount.",
} as const;
